import {Button} from 'antd';

import {AsciiSpinner} from '../../../layout/spinner/ascii-spinner';
import {Locale} from '../../../provider/locale/locale';

import * as styles from './publication-brand-or-companies-field.scss';

type PropsType = {
    // Injected by Form.Item: the mirrored companies-selector count.
    value?: number;
    isCountLoaded: boolean;
    disabled?: boolean;
    onSelect: VoidFunction;
};

// Read-only "Компании: N" row with the button opening the standard companies selector.
export function PublicationSelectedCompaniesInput(props: PropsType): JSX.Element {
    const {value = 0, isCountLoaded, disabled, onSelect} = props;

    return (
        <div className={styles.PublicationBrandOrCompaniesField_companies}>
            <span className={styles.PublicationBrandOrCompaniesField_companiesCount}>
                <Locale
                    stringKey="COMPANY__MULTISELECT__POPUP__COMPANIES_COUNT"
                    valueMap={{count: isCountLoaded ? value : <AsciiSpinner />}}
                />
            </span>

            <Button disabled={disabled || !isCountLoaded} onClick={onSelect} size="small">
                <Locale stringKey="BUTTON__SELECT" />
            </Button>
        </div>
    );
}
